import { OktaAuthConfig } from "./types";

const config = window.OKTA_CONFIG.institutional;
const {
  VITE_OKTA_INSTITUTIONAL_CLIENT_ID,
  VITE_OKTA_ISSUER,
  VITE_OKTA_INSTITUTIONAL_REDIRECT_URI,
} = import.meta.env;
export const institutionalAuthConfig: OktaAuthConfig = {
  clientId: VITE_OKTA_INSTITUTIONAL_CLIENT_ID || config.clientId,
  issuer: VITE_OKTA_ISSUER || config.issuer,
  redirectUri: VITE_OKTA_INSTITUTIONAL_REDIRECT_URI || config.redirectUri,
};
